import { all, takeLatest, put, fork, call } from "redux-saga/effects";
import { REQUEST_LANG } from "../constants/Lookups";
import { receiveLangData } from "../actions/Lookup";
import fetchData from "services/ApiService";
import _ from "lodash";
export function* getLanguages() {
  yield takeLatest(REQUEST_LANG, function* () {
    try {
      const response = yield call(fetchData, "/api/Language");
      if (response.state) {
        const sortedData = _.sortBy(response.data, [
          function (o) {
            return o.locale;
          },
        ]);
        yield put(receiveLangData(sortedData));
      } else {
        yield put();
        // showAuthMessage(
        //   "The password or the username that you've entered is incorrect"
        // )
      }
    } catch (err) {
      // yield put(showAuthMessage(err));
    }
  });
}
export default function* rootSaga() {
  yield all([fork(getLanguages)]);
}
